module.exports = __webpack_public_path__ + "img/colored-paper-19.ff71f2d7.png";